<template>
  <div :class="`${containerClass} form-value-container`">
    <div class="row">
      <div :class="`${labelClass} form-label`">{{ label }}</div>
      <div :class="`${valueClass} form-value`">{{ checkedValue }}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    label: {},
    value: {},
    containerClass: {
      default: "col-2",
    },
    labelClass: {
      default: "col-5",
    },
    valueClass: {
      default: "col-7",
    },
  },
  computed: {
    checkedValue(){
      return this.value ? this.value : '---'
    }
  }
};
</script>
<style scoped>
.form-label {
  color: #000;
  font-weight: 900;
}
.form-value-container {
    padding: 5px;
}
@media (prefers-color-scheme: dark) {
  .form-label {
    color: white;
  }
}
</style>
